import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function About() {
    return (
        <>
            <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900 mt-10">
                عن الخير
            </div>
            <div className="flex flex-col">
                <div className="mt-12 w-full max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
                        <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow self-stretch px-5 py-6 w-full font-medium bg-white rounded-2xl max-md:mt-5 max-md:max-w-full">
                                <div className="flex flex-col self-start w-20 text-3xl font-bold text-right text-blue-900 whitespace-nowrap">
                                    <LazyLoadImage
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/bffad81295061b9e7547fefaeb75b2097c6cb8b23f4a2934497b57a7adf4b63a?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                        className="self-center w-full aspect-square"
                                    />
                                    <div className="mt-5">قصتنا</div>
                                </div>
                                <div className="mt-5 text-lg leading-8 text-right text-zinc-900 max-md:max-w-full">
                                    مؤسسة الخير هي منظمة دولية غير حكومية، مقرها المملكة المتحدة،
                                    تقدم الدعم الإنساني والتنمية الدولية والمساعدات الطارئة والإغاثة
                                    في حالات الكوارث في بعض المناطق الأكثر حرمانًا في العالم. تأسست
                                    مؤسسة الخير عام 2003 ونمت بسرعة لتصبح واحدة من الجمعيات الخيرية
                                    الإنسانية الرائدة في المملكة المتحدة، بدأت رحلتنا عام 2003م وكان
                                    تركيزنا المباشر على قطاع التعليم ثم بدأنا التوسع نحو القطاعات
                                    التنموية المختلفة،{" "}
                                </div>
                                <div className="justify-center self-start px-3.5 py-2 mt-4 text-sm leading-5 whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-neutral-900">
                                    عرض المزيد
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow p-5 w-full font-medium bg-white rounded-2xl max-md:mt-5 max-md:max-w-full">
                                <div className="flex flex-col self-start max-w-full text-3xl font-bold text-right text-blue-900 whitespace-nowrap w-[382px]">
                                    <LazyLoadImage
                                        loading="lazy"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/a676afb9dd5ac683e56ee4e86b447cd1bd23b2c85431fd8d45d2492ce537ed46?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                        className="self-start w-20 aspect-square"
                                    />
                                    <div className="mt-5">الرؤية والرسالة والقيم الأهداف</div>
                                </div>
                                <div className="mt-5 text-lg leading-7 text-right text-zinc-900 max-md:max-w-full">
                                    تمكين الناس من العيش في مجتمعاتهم بكرامة إنسانية، وحصول الفئات
                                    الضعيفة والمهمشة على حقوقها الأساسية دون تمييز.
                                    <br />
                                    <br />
                                    المساهمة في تحقيق التنمية الشاملة والمستدامة في المجتمعات
                                    الضعيفة والمهمشة بما يعزز الحياة الكريمة للفئات المُستهدفة ما
                                    يجعلها قادرة على تحقيق الأثر الإيجابي لنفسها ولمجتمعها.
                                    <br />
                                </div>
                                <div className="justify-center self-start px-3.5 py-2 mt-4 text-sm leading-5 whitespace-nowrap bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-neutral-900">
                                    عرض المزيد
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About